angular.module('gym.components').directive('tasksWidget', function() {
  return {
    restrict: 'EA',
    template: require('templates/components/dashboard/tasks_widget.html.slim'),
    scope: {},
    controller: ["$scope", "$rootScope", "Tasks", "TasksService", function($scope, $rootScope, Tasks, TasksService) {
      var loadTasks;
      $scope.defaultTasksList = $rootScope.defaultTasksList;
      $scope.statuses = TasksService.getStatuses();
      loadTasks = function() {
        return Tasks.all('due').getList({
          count: 3
        }).then(function(tasks) {
          return $scope.tasks = tasks;
        });
      };
      loadTasks();
      $rootScope.$on('tasks:updated', function() {
        return loadTasks();
      });
      $scope.changeStatus = function(task) {
        var action;
        action = (function() {
          switch (task.status) {
            case 'unstarted':
              return 'restart';
            case 'started':
              return 'start';
            case 'waiting':
              return 'wait';
            case 'finished':
              return 'finish';
          }
        })();
        return Tasks.doPUT({
          withoutNamespace: true
        }, `${task.id}/${action}`).then(function() {
          return $scope.$emit('tasks:updated');
        });
      };
      $scope.hasManagePermission = function(task) {
        return TasksService.hasManagePermission(task);
      };
      $scope.displayDate = function(date) {
        return moment(date).calendar();
      };
      return $scope.editTask = function(id) {
        return TasksService.edit(id);
      };
    }]
  };
});
